import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=3e86895d&scoped=true&"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=3e86895d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e86895d",
  null
  
)

export default component.exports